<template>
  <div>
    <page-header>Инструкция для партнёров</page-header>

    <ul>
      <li>
        <a href="/api_watermap.pdf">Скачать инструкцию в pdf</a>
        (api_watermap.pdf)
      </li>
      <!--<li><a href="https://www.dropbox.com/scl/fi/dgw7enadhm1hffjqicov0/API.paper?dl=0&rlkey=ml1ujob8gt3otcj3ro515vuoo">Ссылка на инструкцию в dropbox</a></li>-->
    </ul>
  </div>
</template>

<script>
import PageHeader from "../components/PageHeader";
export default {
  name: "Instructions",
  components: { PageHeader }
};
</script>
